import { render, staticRenderFns } from "./MyDataTable.vue?vue&type=template&id=4eb3a132&"
import script from "./MyDataTable.vue?vue&type=script&lang=js&"
export * from "./MyDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports